import script from "./ServiciosHero.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiciosHero.vue?vue&type=script&setup=true&lang=js"

import "./ServiciosHero.vue?vue&type=style&index=0&id=a0485762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0485762"]])

export default __exports__